import React, { useEffect } from "react";
import { appThemes } from "./themes";
import { AppTheme } from "./types";
import './app-customize.scss';

export const AppCustomize = () => {

    const [currentTheme, setCurrentTheme] = React.useState<AppTheme>(appThemes[0]);

    useEffect(() => {
        const theme = localStorage.getItem("spotip17an-appTheme");
        if (theme) {
            setCurrentTheme(appThemes.find(x => x.id === theme) || appThemes[0]);
        }
    }, []);

    useEffect(() => {
        const body = document.body;

        body.classList.remove(...appThemes.map(x => `theme-${x.id}`));
        if (currentTheme.id) {
            body.classList.add(`theme-${currentTheme.id}`);
            // change body data-bs-theme
            body.setAttribute("data-bs-theme", currentTheme.dark ? "dark" : "light");
        }
        document.dispatchEvent(new CustomEvent("theme-changed", { detail: currentTheme }));

        requestAnimationFrame(() => {
            const themeColor = getComputedStyle(body).getPropertyValue('--bg-body').trim();
            if (themeColor) {
                const meta = document.querySelector('meta[name="theme-color"]');
                if (meta) {
                    meta.setAttribute('content', themeColor);
                }
            }
        });
    }, [currentTheme]);

    const handleSetTheme = (theme: AppTheme) => {
        setCurrentTheme(theme);
        localStorage.setItem("spotip17an-appTheme", theme.id);
    }

    return (
        <div className="app-customize container">
            <h1 className="app-customize__title">Personalizar Apariencia</h1>
            <p className="app-customize__subtitle">Elige un tema para adaptar la interfaz de Spotip17an a tu estilo.</p>

            <div className="app-customize__grid">
                {appThemes.map((theme) => {
                    const isSelected = currentTheme.id === theme.id;
                    return (
                        <div
                            key={theme.id}
                            className={`app-customize__card ${isSelected ? 'app-customize__card--selected' : ''}`}
                            onClick={() => handleSetTheme(theme)}
                        >
                            <div className="app-customize__card-header">
                                <span className="app-customize__card-name">{theme.name}</span>
                                <span className={`badge app-customize__card-badge ${theme.dark ? 'bg-dark' : 'bg-light text-dark'}`}>
                                    {theme.dark ? 'Oscuro' : 'Claro'}
                                </span>
                            </div>

                            <div className="app-customize__color-palette">
                                {theme.colors.map((color, index) => (
                                    <div
                                        key={index}
                                        className="app-customize__color-swatch"
                                        style={{ backgroundColor: color }}
                                        title={color}
                                    />
                                ))}
                            </div>

                            {isSelected && (
                                <div className="app-customize__selected-indicator">
                                    <i className="fa-solid fa-circle-check"></i> Activo
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};